import { basePath } from './config';
import { notification } from 'antd';

export function getOrders(token, idCompany, status) {
    const url = `${basePath}/Order/GetOrders`;

    if (!idCompany) {
        let promResuelta = Promise.resolve({
            error: true,
        });
        return promResuelta;
    }

    const data = {
        CompanyId: idCompany,
        Viewed: status,
        Archived: false,
    };

    const params = {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            Accept: '*/*',
        },
    };

    return fetch(url, params)
        .then((response) => {
            return response.json();
        })
        .then((result) => {
            return result;
        })
        .catch((err) => {
            console.log(err);
            notification['error']({
                message: 'No cuenta conexión a internet',
            });
        });
}

export function getListOrders(token, data) {
    const url = `${basePath}/Order/GetOrders`;

    const params = {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            Accept: '*/*',
        },
    };

    return fetch(url, params)
        .then((response) => {
            return response.json();
        })
        .then((result) => {
            return result;
        })
        .catch((err) => {
            console.log(err);
            notification['error']({
                message: 'No cuenta conexión a internet',
            });
        });
}

export function getOrderReportApi(token, data) {
    const url = `${basePath}/Order/GetOrderReport`;

    const params = {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            Accept: '*/*',
        },
    };

    return fetch(url, params)
        .then((response) => {
            return response.json();
        })
        .then((result) => {
            return result;
        })
        .catch((err) => {
            console.log(err);
            notification['error']({
                message: 'No cuenta conexión a internet',
            });
        });
}

export function getTopSelling(token, data) {
    const url = `${basePath}/Order/GetTopSelling`;

    const params = {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            Accept: '*/*',
        },
    };

    return fetch(url, params)
        .then((response) => {
            return response.json();
        })
        .then((result) => {
            return result;
        })
        .catch((err) => {
            console.log(err);
            notification['error']({
                message: 'No cuenta conexión a internet',
            });
        });
}

export function getAllOrders(token, idCompany) {
    const url = `${basePath}/Order/GetOrders`;

    if (!idCompany) {
        let promResuelta = Promise.resolve({
            error: true,
        });
        return promResuelta;
    }

    const data = {
        CompanyId: idCompany,
        Archived: false,
    };

    const params = {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            Accept: '*/*',
        },
    };

    return fetch(url, params)
        .then((response) => {
            return response.json();
        })
        .then((result) => {
            return result;
        })
        .catch((err) => {
            console.log(err);
            notification['error']({
                message: 'No cuenta conexión a internet',
            });
        });
}

export function getOrderAdmin(token, data) {
    const url = `${basePath}/Order/GetOrder`;

    const params = {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            Accept: '*/*',
        },
    };

    return fetch(url, params)
        .then((response) => {
            return response.json();
        })
        .then((result) => {
            return result;
        })
        .catch((err) => {
            console.log(err);
            notification['error']({
                message: 'No cuenta conexión a internet',
            });
        });
}

export function editOrderStatus(token, data) {
    const url = `${basePath}/Order/EditOrderStatus`;

    const params = {
        method: 'PUT',
        body: JSON.stringify(data),
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            Accept: '*/*',
        },
    };

    return fetch(url, params)
        .then((response) => {
            return response.json();
        })
        .then((result) => {
            return result;
        })
        .catch((err) => {
            console.log(err);
            notification['error']({
                message: 'No cuenta conexión a internet',
            });
        });
}

export function editOrder(token, data) {
    const url = `${basePath}/Order/EditOrder`;

    const params = {
        method: 'PUT',
        body: JSON.stringify(data),
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            Accept: '*/*',
        },
    };

    return fetch(url, params)
        .then((response) => {
            return response.json();
        })
        .then((result) => {
            return result;
        })
        .catch((err) => {
            console.log(err);
        });
}

export function createOrderApi(token, data) {
    const url = `${basePath}/Order/CreateOrder`;

    const params = {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            Accept: '*/*',
        },
    };

    return fetch(url, params)
        .then((response) => {
            return response.json();
        })
        .then((result) => {
            return result;
        })
        .catch((err) => {
            console.log(err);
            notification['error']({
                message: 'No cuenta conexión a internet',
            });
        });
}
export function getOrderApi(token, idCompany, orderId) {
    const url = `${basePath}/Order/GetOrder`;

    if (!idCompany) {
        let promResuelta = Promise.resolve({
            error: true,
        });
        return promResuelta;
    }

    const data = {
        CompanyId: idCompany,
        OrderId: orderId,
    };

    const params = {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            Accept: '*/*',
        },
    };

    return fetch(url, params)
        .then((response) => {
            return response.json();
        })
        .then((result) => {
            return result;
        })
        .catch((err) => {
            console.log(err);
            notification['error']({
                message: 'No cuenta conexión a internet',
            });
        });
}

export function getActiveOrderApi(token) {
    const url = `${basePath}/Order/GetActiveOrder`;

    // if (!idCompany) {
    //     let promResuelta = Promise.resolve({
    //         error: true,
    //     });
    //     return promResuelta;
    // }

    // const data = {
    //     CompanyId: idCompany,
    //     ClientId: clientId,
    // };

    const params = {
        method: 'GET',
        // body: JSON.stringify(data),
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            Accept: '*/*',
        },
    };

    return fetch(url, params)
        .then((response) => {
            return response.json();
        })
        .then((result) => {
            return result;
        })
        .catch((err) => {
            console.log(err);
            notification['error']({
                message: 'No cuenta conexión a internet',
            });
        });
}

export function archiveOrdersApi(token, data) {
    const url = `${basePath}/Order/ArchiveOrders`;

    const params = {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            Accept: '*/*',
        },
    };

    return fetch(url, params)
        .then((response) => {
            return response.text();
        })
        .then((result) => {
            return result;
        })
        .catch((err) => {
            console.log(err);
            notification['error']({
                message: 'No cuenta conexión a internet',
            });
        });
}

export function deleteOrderDetailApi(token, data) {
    const url = `${basePath}/Order/DeleteOrderDetail`;

    const params = {
        method: 'DELETE',
        body: JSON.stringify(data),
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            Accept: '*/*',
        },
    };

    return fetch(url, params)
        .then((response) => {
            return response.json();
        })
        .then((result) => {
            return result;
        })
        .catch((err) => {
            console.log(err);
        });
}

export function getGraphicOrderReportApi(token, data) {
    const url = `${basePath}/Order/GetGraphicOrderReport`;

    const params = {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            Accept: '*/*',
        },
    };

    return fetch(url, params)
        .then((response) => {
            return response.json();
        })
        .then((result) => {
            return result;
        })
        .catch((err) => {
            console.log(err);
            notification['error']({
                message: 'No cuenta conexión a internet',
            });
        });
}
//CREAR COMENTARIO
export function createComment(token, data, id) {
    const url = `${basePath}/Order/${id}/Comment`;

    const params = {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "*/*",
        },
    };

    return fetch(url, params)
        .then((response) => {
            return response.json();
        })
        .then((result) => {
            return result;
        })
        .catch((err) => {
            console.log(err);
            notification["error"]({
                message: "No cuenta conexión a internet",
            });
        });
}
//GET COMENTARIO
export function getComments(token, id) {
    const url = `${basePath}/Order/${id}/Comment`;

    const params = {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "*/*",
        },
    };

    return fetch(url, params)
        .then((response) => {
            return response.json();
        })
        .then((result) => {
            return result;
        })
        .catch((err) => {
            console.log(err);
            notification["error"]({
                message: "No cuenta conexión a internet",
            });
        });
}
